import { api } from "./client.js";

export const v1ConnectionApi = {
  // GET /api/v1/connections/source-control
  listSourceControl: () => api.get("/v1/connections/source-control").then(r => r.data),
  
  // GET /api/v1/connections/work-items
  listWorkItems: () => api.get("/v1/connections/work-items").then(r => r.data),

  // GET /api/v1/connections/llm
  listLLMs: () => api.get("/v1/connections/llm").then(r => r.data),
};
